import Vue from "vue"
import AppService from "@/AppService"

export default new Vue({
  name: "AuthService",
  data: {},
  methods: {
    /**
     * accessText
     * @param {array} services
     */
    accessText(services) {
      let text = ""
      let accessArray = []
      this.$lodash.forEach(services, (service) => {
        if (service === AppService.getMvatsServiceString()) {
          accessArray.push("Metadata Rules")
        }
        if (service === AppService.getOpsUIServiceString()) {
          accessArray.push("Pre Ingest")
          accessArray.push("Provider Groups")
          accessArray.push("Providers")
        }
      })
      text += accessArray.join(", ")
      return text
    }
  }
})



// WEBPACK FOOTER //
// ./src/Auth/AuthService.js